"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../common/utils");
const addRoot = (wrapperItems) => {
    return (BaseClass) => {
        return class extends BaseClass {
            getRoot() {
                return utils_1.getFirstWrapper(wrapperItems).value.root;
            }
        };
    };
};
exports.addRoot = addRoot;
const addRootByName = (wrapperItems) => {
    return (wrapperName) => {
        return (BaseClass) => {
            return class extends BaseClass {
                getRoot() {
                    return utils_1.getWrapper(wrapperItems, wrapperName).root;
                }
            };
        };
    };
};
exports.addRootByName = addRootByName;
const getRoot = (wrapperItems) => {
    return (wrapperName) => {
        if (wrapperName) {
            return utils_1.getWrapper(wrapperItems, wrapperName).root;
        }
        else {
            return utils_1.getFirstWrapper(wrapperItems).value.root;
        }
    };
};
exports.getRoot = getRoot;
//# sourceMappingURL=add-root.js.map